module.exports = __webpack_public_path__ + "static/media/prx_02.a39ea606.png";